export default {"src":"/_next/static/image/public/images/ic_rx_hc.bbceafd2bd40f978079f71bd94331ae1.svg","height":11,"width":10};